function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import FilePickerSource from './file-picker-source';
import { LaptopOutlined } from '@ant-design/icons';
var TYPE = 'my-device'; // tslint:disable-next-line:function-name

function MyDeviceSource(props) {
  return /*#__PURE__*/React.createElement(FilePickerSource, _extends({}, props, {
    type: TYPE
  }));
}

MyDeviceSource.type = TYPE;
MyDeviceSource.defaultLabel = 'My Device';
MyDeviceSource.defaultIcon = /*#__PURE__*/React.createElement(LaptopOutlined, null);
export default MyDeviceSource;